import React from "react";

export default function MPSetting() {
  return <div>MPSetting</div>;
}
